import { ReactNode } from 'react';

interface DivProps {
  className?: string;
  onClick?: (e: any) => void;
  refDiv?: any;
  id?: string;
  dangerouslySetInnerHTML?: any;
  onFocus?: () => void;
  onBlur?: () => void;
  style?: any;
  onTouchMove?: () => void;
  onTouchEnd?: () => void;
  onTouchStart?: () => void;
  dataTag?: string;
  children?: ReactNode;
}
function Div(props: DivProps) {
  return (
    // eslint-disable-next-line
    <div
      className={props.className}
      onClick={props.onClick || (() => {})}
      ref={props.refDiv || undefined}
      tabIndex={typeof props.onClick === 'function' ? 0 : undefined}
      role={typeof props.onClick === 'function' ? 'button' : ''}
      id={props.id || 'div'}
      data-cy={props.id || 'div'}
      dangerouslySetInnerHTML={props.dangerouslySetInnerHTML || undefined}
      onMouseEnter={props.onFocus || (() => {})}
      onMouseLeave={props.onBlur || (() => {})}
      style={props.style}
      onTouchMove={props.onTouchMove}
      onTouchEnd={props.onTouchEnd}
      onTouchStart={props.onTouchStart}
      data-tag={props.dataTag}>
      {props.children || null}
    </div>
  );
}

export default Div;
